export type AssistantCompletedTaskAnnouncementDisposition =
  | 'announce'
  | 'skip-hydration'
  | 'defer-until-match'
  | 'settle-silently';

export const resolveCompletedTaskAnnouncementDisposition = (input: {
  hydratingCompletedTasks: boolean;
  shouldAnnounceInConversation: boolean;
  hasPendingConversationLaunches: boolean;
}): AssistantCompletedTaskAnnouncementDisposition => {
  if (input.shouldAnnounceInConversation) {
    return 'announce';
  }
  if (input.hydratingCompletedTasks) {
    return 'skip-hydration';
  }
  if (input.hasPendingConversationLaunches) {
    return 'defer-until-match';
  }
  return 'settle-silently';
};
